module.exports = __webpack_public_path__ + "img/phone.892f0769.png";